import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { Button, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  getAllComponents,
  getUsersByOrgId,
  postAppsInRole,
  postRole,
  postUsersInRole,
} from "../../api/broker";
import { Spinner } from "../../components/Loading/Spinner";
import RoleDetailsForm from "../../components/Table/Roles/CreateRole/RoleDetailsForm";
import SelectAppsAndUsers from "../../components/Table/Roles/CreateRole/SelectAppsAndUsers";
import { DBComponente } from "../../interfaces/SuperAdmin/Others/iDataComponentes";
import { PostRoleFields } from "../../interfaces/SuperAdmin/Pages/iDataRoles";
import { iDataUser } from "../../interfaces/SuperAdmin/Pages/iDataUser";

const CreateRole = () => {
  const navigate = useNavigate();
  const { control, handleSubmit } = useForm<PostRoleFields>();
  const { idOrganization } = useParams();

  const [apps, setApps] = useState<DBComponente[]>([]);
  const [allUsers, setAllUsers] = useState<iDataUser[]>([]);

  const [selectedApps, setSelectedApps] = useState<string[]>([]);
  const [selectedUsers, setSelectedUsers] = useState<string[]>([]);

  const [isLoading, setIsLoading] = useState(true);
  const [isCreating, setIsCreating] = useState(false);

  // Fetch de los componentes y usuarios seleccionables
  const fetchUsersAndApps = async () => {
    if (idOrganization) {
      setIsLoading(true);
      try {
        const [usersRes, appRes] = await Promise.all([
          getUsersByOrgId(idOrganization),
          getAllComponents(),
        ]);

        if (
          usersRes.data.statusCode === 200 &&
          appRes.data.statusCode === 200
        ) {
          setAllUsers(usersRes.data.body);
          setApps(appRes.data.body);
        } else {
          toast.error("Error al traer los usuarios y/o apps");
        }
      } catch (error) {
        console.log(error);
        toast.error("Error al traer los usuarios y/o apps");
      } finally {
        setIsLoading(false);
      }
    }
  };

  // Hacemos el fetch al renderizar la página
  useEffect(() => {
    fetchUsersAndApps();
  }, []);

  // Submit del rol
  const onSubmit = async (data: PostRoleFields) => {
    if (idOrganization) {
      data.id_organizacion = idOrganization;

      setIsCreating(true);
      try {
        const roleRes = await postRole(data); //Creamos el rol primero
        console.log(roleRes);

        //Si se creó con éxito, creamos los permisos y usuarios
        if (roleRes.data.statusCode === 201) {
          //body de componentes
          const appBody = {
            id_rol: roleRes.data.body.id_rol,
            id_componentes: selectedApps,
          };

          //body de usuarios
          const userBody = {
            id_rol: roleRes.data.body.id_rol,
            id_usuarios: selectedUsers,
          };

          //Hacemos los fetch
          const [appRes, userRes] = await Promise.all([
            postAppsInRole(appBody),
            postUsersInRole(userBody),
          ]);

          if (
            appRes.data.statusCode === 201 &&
            userRes.data.statusCode === 201
          ) {
            navigate(-1);
            toast.success("Rol creado exitosamente");
          } else {
            toast.error("Error al crear rol");
          }
        }
      } catch (error) {
        toast.error("Error al crear rol");
      } finally {
        setIsCreating(false);
      }
      console.log("Rol creado:", data);

      console.log("Apps agregadas:", selectedApps);

      console.log("Usuarios agregados:", selectedUsers);
    }
  };

  return (
    <Grid
      container
      spacing={4}
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        pt: 3,
        color: "#336B87",
      }}
    >
      {/* Boton para volver */}
      <Grid item>
        <Button sx={{ color: "#336B87" }} onClick={() => navigate(-1)}>
          <ArrowBackOutlinedIcon />
          Volver
        </Button>
      </Grid>

      {/* Título */}
      <Grid item>
        <Typography variant={"h4"} sx={{ color: "#005559", fontSize: "30px" }}>
          <b>Roles</b> | Crear rol
        </Typography>
      </Grid>

      {isLoading ? (
        <Grid item>
          <Spinner msg="Cargando por favor espere..." />
        </Grid>
      ) : (
        <>
          {/* Form detalles del rol */}
          <Grid item>
            <RoleDetailsForm
              control={control}
              handleSubmit={handleSubmit(onSubmit)}
              id_organizacion={idOrganization as string}
              isCreating={isCreating}
            />
          </Grid>

          {/* Select de apps y usuarios */}
          <Grid item>
            <SelectAppsAndUsers
              allUsers={allUsers}
              apps={apps}
              selectedApps={selectedApps}
              selectedUsers={selectedUsers}
              setSelectedApps={setSelectedApps}
              setSelectedUsers={setSelectedUsers}
              isCreating={isCreating}
            />
          </Grid>

          {/* Botón de enviar fuera del form */}
          <Grid item display={"flex"} justifyContent={"start"}>
            <Button
              onClick={handleSubmit(onSubmit)}
              variant="contained"
              sx={{ background: "#336B87" }}
              disabled={isCreating}
            >
              Crear Rol
            </Button>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default CreateRole;
